import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import { ActivityCounter, BlobNavbarCounts } from 'src/components/Header/BlobNavbarCounters';
import { ProgressSegments } from '../SessionProgress';
import * as S from './styles';

const msgs = defineMessages({
  exit: { id: 'learning_session_tooltip_exit' },
});

type MobileTopBarProps = {
  percentComplete: number;
  itemCount: number;
  counts?: BlobNavbarCounts;
  onExit: () => void;
  /** Dark icons/progress for a light card background (no media behind the bar) */
  light?: boolean;
};

export const MobileTopBar: FC<MobileTopBarProps> = ({
  percentComplete,
  itemCount,
  counts,
  onExit,
  light = false,
}) => {
  const intl = useIntl();

  return (
    <S.TopBar $light={light} data-testid="blob-mobile-top-bar">
      <S.Row>
        <S.BackButton
          type="button"
          onClick={onExit}
          aria-label={intl.formatMessage(msgs.exit)}
          data-testid="blob-session-exit"
        >
          <Icon name="chevronLeft" />
        </S.BackButton>
        <S.Stats data-testid="blob-session-stats">
          <ActivityCounter activity="review" value={counts?.reviewCount} />
          <ActivityCounter activity="learn" value={counts?.learningCount} />
        </S.Stats>
      </S.Row>
      <ProgressSegments percentComplete={percentComplete} itemCount={itemCount} overlay={!light} />
    </S.TopBar>
  );
};
